import { Component, Input, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { AdminMe } from '@core/domains/adminMe/admin-me';
import { LoginService } from '@core/auth/login.service';
import { SAAS_URL_FILTER } from '@core/constants/products.constant';

@Component({
    selector: 'account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'layout' } }],
    standalone: false
})
export class AccountComponent implements OnInit {
  hasSaasUrlFilter: boolean;
  @Input() admin: AdminMe;
  @Input() color: ThemePalette = 'primary';

  constructor(private loginService: LoginService) { }

  ngOnInit(): void {
    this.hasSaasUrlFilter = this.admin.products.includes(SAAS_URL_FILTER);
  }

  logout(): void {
    this.loginService.onLogout();
  }
}
